<template>
  <v-form v-model="isValid" ref="forgotPasswordForm" @submit.prevent="submitMobileNum" class="d-flex justify-center flex-column" :class="$vuetify.breakpoint.lgAndUp ? 'mx-auto' : 'w-100'">
    <v-card-text class="d-flex flex-column align-center" :class="!$vuetify.breakpoint.lgAndUp && ' px-0 mx-0'">
      <span class="mb-8 text-center">{{ $t('message.mobileNumberPromptForReset') }}</span>
      <MobileNumberField v-model="form.mobileNumber" :rules="$rules.mobileNumberRules" :error-messages="mobileNumberErrors" @input="submissionErrors.mobileNumber = ''" />

      <v-expand-transition>
        <p class="error--text text-center text-mini" v-show="submissionErrors.smsError">{{ submissionErrors.smsError }}</p>
      </v-expand-transition>
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-stretch px-4">
      <v-btn color="primary" class="mx-5 mb-5 d-block rounded-pill green-gradient-right text-capitalize override-disabled-styles" :loading="loading" type="submit" :disabled="!isValid">
        {{ $t('label.sendOtp') }}
      </v-btn>
      <v-btn class="align-self-center primary--text" icon fab @click="$emit('prev-step')"><LeftArrow /></v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

import MobileNumberField from '@/components/fields/MobileNumberField'
import { OTP_Type } from '@/constants/enums'
import LeftArrow from '@/assets/icons/left-arrow-circle.svg'

export default {
  components: { MobileNumberField, LeftArrow },

  data: () => ({
    loading: false,
    isValid: false,
    form: {
      mobileNumber: ''
    },
    submissionErrors: {
      mobileNumber: '',
      smsError: ''
    }
  }),

  computed: {
    mobileNumberErrors() {
      const errors = []
      this.submissionErrors.mobileNumber && errors.push(this.submissionErrors.mobileNumber)
      return errors
    }
  },

  methods: {
    ...mapActions('common', ['requestOTP']),
    async submitMobileNum() {
      this.loading = true
      await this.requestOTP({
        ...this.form,
        type: OTP_Type.RESET_PASSWORD
      })
        .then(() => {
          this.$emit('next-step')
        })
        .catch((err) => {
          this.submissionErrors.mobileNumber = err.error_message
          this.submissionErrors.smsError = err.message
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
